import React from 'react'

const ServiceHealthStatus = () => {
    return (
        <div>Service is up and running!!!</div>
    )
}

export default ServiceHealthStatus